import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

import { Contrato, IDataPreventa, IDataReferido, TIPO_PLAN_CORPORATIVO_CHOICE, TiposReferidosENUM } from "../interfaces"
import { EstadoComponente } from "../components/ui"
import {
  emptyCell, emptyCellOneLevel, formatDateWithTimeAMPM, getEnvs, cellLineaRazonSocial,
  cellNotFilter, formatDate, emptyCellObject, calcColorStatusGeneral
} from "../utils"
import CopyTextOnClickComponent from "../components/ui/CopyTextOnClick/CopyTextOnClickComponent"
import {
  EstadoPreventaEnum, TIPO_FORMA_PAGO_CHOICE, TIPO_IDENTIFICACIONES_CHOICE, TIPO_PLANES_CHOICE,
  TIPO_REFERIDO_PREVENTA_CHOICE, TIPO_SERVICIOS_CHOICE, TipoFormaPagoEnumChoice
} from "../constants"
import InfoUser from "../components/ui/InfoUser/InfoUser"
import { EquipoAdicionalIconBtnCellModal } from "@/erp/operaciones/preagendamiento/shared/components"
import dayjs from "dayjs"
import { ShowContractsAgendaModal } from "@/erp/operaciones/agendamiento/shared/components/forms"
import { IPreventaCorporativo } from "../interfaces/erp/preventa/preventa_corporativo.interface"
import { Button, Chip, Tooltip, Typography } from "@mui/material"
import { openGenericObjectModal } from "../components/ui/ModalGenericObject/useGenericObjectModalStore"
import { fieldObservacionPreventa, fieldPlan, fieldReferido } from "../utils/fields-modal-generic-object"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const { VITE_API_URL_OFICINA_VIRTUAL } = getEnvs();


export const fnReferido = (row: IDataPreventa): IDataReferido => {

  switch (row.tipo_referido) {
    case TiposReferidosENUM.FLOTA:
      return {
        contacto: row.referido_flota_data?.telefono_1!,
        identificacion: row.referido_flota_data?.numero_referencia!,
        nombre: row.referido_flota_data?.lider!,
        tipo: TiposReferidosENUM.FLOTA,
      }
    case TiposReferidosENUM.CLIENTE:
      return {
        contacto: row.referido_cliente_data?.celular!,
        identificacion: row.referido_cliente_data?.identificacion!,
        nombre: row.referido_cliente_data?.razon_social!,
        tipo: TiposReferidosENUM.CLIENTE,

      }
    default:
      return {
        contacto: 'N/A',
        identificacion: 'N/A',
        nombre: 'N/A',
        tipo: TiposReferidosENUM.NA,
      }
  }
}

export const fnTipoContrato = (pre_requiere_contrato_fisico: boolean, requiere_contrato_fisico: boolean): {
  texto: string;
  color: string;
} => {

  if (requiere_contrato_fisico) {
    return {
      texto: 'CONTRATO FISICO',
      color: 'green'
    }
  }
  if (pre_requiere_contrato_fisico && !requiere_contrato_fisico) {
    return {
      texto: 'PENDIENTE',
      color: '#FF8040'
    }
  }
  return {
    texto: 'CONTRATO DIGITAL',
    color: '#0046FF'
  }

}

export const useTableColumnsPreventa = (_estado: EstadoPreventaEnum) => {


  const columnsPreventa = useMemo<MRT_ColumnDef<IDataPreventa>[]>(() => [
    {
      accessorKey: 'cliente_razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data.identificacion
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data.tipo_identificacion
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'requiere_contrato_fisico',
      header: 'Tipo de Contrato',
      size: 250,
      Cell: ({ row }) => {

        const info = fnTipoContrato(
          row.original.pre_requiere_contrato_fisico, row.original.requiere_contrato_fisico);

        return <EstadoComponente
          backgroundColor={info.color}
          texto={info.texto} />
      }
    },
    {
      accessorKey: 'estado_aceptacion',
      header: 'Estado Aceptacion',
      filterVariant: 'select',
      filterSelectOptions: [{ label: 'FIRMADO', value: 'true' }, { label: 'PENDIENTE FIRMAR', value: 'false' }],
      size: 200,
      Cell: ({ row }) => (
        <EstadoComponente backgroundColor={row.original.estado_aceptacion ? 'green' : 'orange'} texto={row.original.estado_aceptacion ? 'FIRMADO' : 'PENDIENTE FIRMAR'} />
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'contrato_data_documentos',
      header: 'Documentos',
      Cell: ({ row }) => (
        <ShowContractsAgendaModal
          razonSocial={cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)}
          contrato={row.original.contrato_data!}
          tooltipMessage={"Documentos generados"}
          idPreventa={row.original.id_preventa}
          //solo para pyl
          showBtnGenDocs={false}
          showBtnCopy={true}

          contratoFisico={row.original.pre_requiere_contrato_fisico || row.original.requiere_contrato_fisico}
          showBtnGenAutorizacion={
            (row.original.forma_pago_data?.forma_pago != TipoFormaPagoEnumChoice.RECAUDACION && (
              !row.original.url_autorizacion_debito_automatico && !row.original.url_autorizacion_cargo_tarjeta
            )) ? true : false
          }
          formaPago={row.original.forma_pago_data?.forma_pago!}
          url_autorizacion_cargo_tarjeta={row.original.url_autorizacion_cargo_tarjeta}
          url_autorizacion_debito_automatico={row.original.url_autorizacion_debito_automatico}
          urlFirmaDigital={row.original.url_link_firma}
        />
      )
    },

    {
      ...cellNotFilter,
      accessorKey: 'prospecto_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    {
      accessorKey: 'email',
      header: 'email',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_info.nombre',
      header: 'estado',
      size: 200,
      Cell: ({ row }) => (
        row.original.estado_preventa != null ?
          <EstadoComponente
            backgroundColor={calcColorStatusGeneral(row.original.estado_preventa)}
            texto={row.original.estado_preventa || ''} /> : null
      ),
    },


    ///* referido
    {
      accessorKey: 'tipo_referido',
      header: 'Medio de Referencia',
      size: 150,
      Cell: ({ row }) => (
        row.original.tipo_referido
          ? <Button
            startIcon={<OpenInNewIcon />}
            onClick={() => {
              const info = fnReferido(row.original);
              openGenericObjectModal({
                data: {
                  tipo_referido: row.original.tipo_referido,
                  nombre_referido: info.nombre,
                  identificacion_referido: info.identificacion,
                  contacto_referido: info.contacto,
                },
                fields: fieldReferido,
                title: "Información de Referido",
                emptyFallback: "—",
              });
            }}
          >
            {row.original.tipo_referido}
          </Button>
          : 'NO'
      ),
    },

    {
      accessorKey: 'tipo_instalacion',
      header: 'tipo instalacion',
      filterVariant: 'select',
      filterSelectOptions: TIPO_REFERIDO_PREVENTA_CHOICE,
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'promocion',
      header: 'promocion',
      size: 200,
      Cell: ({ row }) => (
        row.original.promociones_data.length > 0
          ?
          <Chip
            color="info"
            label={row.original.promociones_data[0].nombre}
          />
          : '—'
      ),
    },

    {
      accessorKey: 'forma_pago',
      header: 'forma pago',
      filterVariant: 'select',
      filterSelectOptions: TIPO_FORMA_PAGO_CHOICE,
      size: 200,
      Cell: ({ row }) => (
        emptyCellObject(row.original.forma_pago_data, 'alias')
      )
    },
    {
      accessorKey: 'tipo_servicio',
      header: 'tipo servicio',
      filterVariant: 'select',
      filterSelectOptions: TIPO_SERVICIOS_CHOICE,
      size: 100,
    },

    ///* informacion plan
    {
      accessorKey: 'tipo_plan',
      header: 'Plan',
      filterVariant: 'select',
      size: 200,
      filterSelectOptions: TIPO_PLANES_CHOICE,
      Cell: ({ row }) => (
        row.original.plan_data
          ? <Button
            startIcon={<OpenInNewIcon />}
            onClick={() => {
              openGenericObjectModal({
                data: row.original.plan_data!,
                fields: fieldPlan,
                title: "Plan",
                emptyFallback: "—",
              });
            }}
          >
            {row.original.plan_data.nombre}
          </Button>
          : '—'
      ),
    },

    {
      accessorKey: 'valor_instalacion_total',
      header: 'valor instalacion total',
      size: 100,
    },
    {
      ...cellNotFilter,
      accessorKey: 'equipos_adicionales',
      header: 'Equipos adicionales',
      size: 30,
      Cell: ({ row }) => (
        <EquipoAdicionalIconBtnCellModal
          equipoAdicional={row.original.equipos_adicionales ?? []}
        />
      ),
    },

    ///* motivo rechazo
    {
      accessorKey: 'motivo_rechazo',
      header: 'Motivo Rechazo',
      size: 200,
      Cell: ({ row }) => (
        emptyCellObject(row.original.motivo_rechazo_data, 'nombre')
      )
    },
    {
      accessorKey: 'observaciones',
      header: 'Observaciones',
      Cell: ({ row }) => (
        <Button
          startIcon={<OpenInNewIcon />}
          onClick={() => {
            openGenericObjectModal({
              data: row.original.observaciones,
              fields: fieldObservacionPreventa,
              title: "Plan",
              emptyFallback: "—",
            });
          }}
        >
          VER
        </Button>
      ),
    },

    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta',
      size: 200
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 200,
      Cell: ({ row }) => (
        <InfoUser user={row.original.user_create}
        />
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'Fecha creación',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
  ], []);


  const columnsPreventaEspera = useMemo<MRT_ColumnDef<IDataPreventa>[]>(() => [
    ...columnsPreventa,
  ], []);


  const columnsPreventaContratosNovedades = useMemo<MRT_ColumnDef<Contrato>[]>(() => [
    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original, row.original.cliente_data!.razon_social)
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original.cliente_data!.identificacion
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      size: 100,
      Cell: ({ row }) => (
        row.original.cliente_data!.tipo_identificacion
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'motivo_rechazo_data',
      header: 'Motivo Contrato',
      size: 200,
      Cell: ({ row }) => (
        row.original?.observaciones_contrato!?.contenido?.length > 0 ?
          row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]
            ?.motivos?.filter(x => x.includes(`- VENTAS`))?.toString() //antes
          : row.original?.motivo_rechazo_data?.nombre ?
            row.original?.motivo_rechazo_data?.nombre
            : "N/A"
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_validacion',
      header: 'Observación Contrato',
      size: 200,

      Cell: ({ row }) => (

        row.original?.observaciones_contrato!?.contenido?.length > 0 ?
          (row.original?.observaciones_contrato!?.contenido.slice(-1)[0] as any)?.migrado ?
            row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones
            //anterior a la fecha    
            : row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones_ventas ?
              row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones_ventas?.slice(0, 100)
              : row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones?.slice(0, 100)
          : row.original?.observaciones?.observacion_update_cliente ?
            row.original?.observaciones?.observacion_update_cliente
            : "N/A"


        // row.original?.observaciones_contrato!?.contenido?.length > 0 ? 
        //   row.original?.observaciones_contrato!?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones.length>100?
        //     row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones.slice(0, 100) + "..."
        //   : row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones.slice(0, 100)
        // :"N/A"
        // emptyCell(row.original.observaciones?.observacion_update_cliente)
      )
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero_referencia',
      size: 200,
    },

    {
      ...cellNotFilter,
      accessorKey: 'cliente_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'fecha preventa',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion!)
      ),
    },
    {
      // ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 100,
      Cell: ({ row }) => {
        return row.original.user_create != null ?
          <InfoUser user={row.original.user_create} /> : 'N/A'
      },
    },

  ], []);



  const columnsPlantaExternaContratosNovedades = useMemo<MRT_ColumnDef<Contrato>[]>(() => [
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      size: 100,
      Cell: ({ row }) => (
        row.original.cliente_data!.tipo_identificacion
      )
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original.cliente_data!.identificacion
      )
    },
    {
      accessorKey: 'razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original, row.original.cliente_data!.razon_social)
      ),
    },
    {
      accessorKey: 'flota_nombre',
      header: 'flota',
      size: 200,
      Cell: ({ row }) => (
        row.original?.flota_data?.nombre
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'motivo_rechazo_data',
      header: 'Motivo Contrato',
      size: 400,
      Cell: ({ row }) => (
        row.original?.observaciones_contrato!?.contenido?.length > 0 ?
          row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]
            ?.motivos?.filter(x => x.includes(`- TECNICO`))?.toString()
          : row.original?.motivo_rechazo_data?.nombre ?
            row.original?.motivo_rechazo_data?.nombre
            : "N/A"
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_validacion',
      header: 'Observación Contrato',
      size: 600,
      Cell: ({ row }) => (
        row.original?.observaciones_contrato!?.contenido?.length > 0 ?
          row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones_tecnico ?
            row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones_tecnico
            : row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones
          : row.original?.observaciones?.observacion_update_cliente ?
            row.original?.observaciones?.observacion_update_cliente
            : "N/A"

        // row.original?.observaciones_contrato!?.contenido?.length > 0 ? 
        //   row.original?.observaciones_contrato?.contenido[row.original?.observaciones_contrato?.contenido.length - 1]?.observaciones
        // :"N/A"
        // emptyCell(row.original.observaciones?.observacion_update_cliente)
      )
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero_referencia',
      size: 200,
    },

    {
      ...cellNotFilter,
      accessorKey: 'cliente_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    // {
    //   ...cellNotFilter,
    //   accessorKey: 'fecha_creacion',
    //   header: 'fecha preventa',
    //   size: 200,
    //   Cell: ({ row }) => (
    //     formatDateWithTimeAMPM(row.original.fecha_creacion!)
    //   ),
    // },
    {
      accessorKey: 'fecha_instalacion',
      header: 'Fecha Instalacion',
      enableColumnFilter: false,
      size: 200,
      Cell: ({ row }) =>
        row.original?.fecha_hora_instalacion ? dayjs(row.original?.fecha_hora_instalacion).format("LLL") : 'N/A',
    },
    {
      accessorKey: 'provincia_nombre',
      header: 'Provincia',
      size: 200,
      Cell: ({ row }) =>
        row.original?.provincia_data?.nombre || 'N/A',
      // row.original?.cliente_data?.provincia_data?.nombre || 'N/A',
    },
    {
      accessorKey: 'ciudad_nombre',
      header: 'Ciudad',
      size: 200,
      Cell: ({ row }) =>
        row.original?.ciudad_data?.nombre || 'N/A',
      // row.original?.cliente_data?.provincia_data?.nombre || 'N/A',
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return row.original.user_create != null ?
          <InfoUser user={row.original.user_create} /> : 'N/A'
      },
    },

  ], []);

  const columnsPendienteActualizarIA = useMemo<MRT_ColumnDef<IDataPreventa>[]>(() => [
    {
      accessorKey: 'prospecto_data.razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)
      ),
    },
    {
      accessorKey: 'prospecto_data.identificacion',
      header: 'Identificacion',
      size: 200,
    },
    {
      accessorKey: 'prospecto_data.tipo_identificacion',
      header: 'Tipo Documento',
      size: 100,
    },
    {
      accessorKey: 'estado_validacion',
      header: 'Errores detectados',
      size: 200,
      Cell: ({ row }) => (
        row.original.errores.map(v => v).join(',')
      )
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero_referencia',
      size: 200,
    },

    {
      accessorKey: 'prospecto_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    {
      accessorKey: 'email',
      header: 'email',
      size: 200,
    },
    {
      accessorKey: 'tipo_referido',
      header: 'Es Referido',
      size: 150,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.tipo_referido
          ? 'SI'
          : 'NO'
      ),
    },
    {
      accessorKey: 'tipo_referido',
      header: 'Medio de Referencia',
      size: 150,
      Cell: ({ row }) => (
        emptyCell(row.original.tipo_referido)
      )
    },
    {
      accessorKey: 'nombre_referencia',
      header: 'Nombre Referencia',
      size: 300,
      Cell: ({ row }) => (
        fnReferido(row.original).nombre
      ),
    },
    {
      accessorKey: 'identificacion_referencia',
      header: 'Identificación de Referencia',
      size: 300,
      Cell: ({ row }) => (
        fnReferido(row.original).identificacion
      ),
    },
    {
      accessorKey: 'contacto_referencia',
      header: 'Contacto de Referencia',
      size: 300,
      Cell: ({ row }) => (
        fnReferido(row.original).contacto
      ),
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'fecha preventa',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
    {
      accessorKey: 'tipo_instalacion',
      header: 'tipo instalacion',
      size: 200,
    },
    {
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return row.original.user_create != null ?
          <InfoUser user={row.original.user_create} /> : 'N/A'
      },
    },
  ], []);

  //Columna para referidos
  const columnsReferido = useMemo<MRT_ColumnDef<IDataPreventa>[]>(() => [
    {
      accessorKey: 'cliente_razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => row.original.prospecto_data.identificacion
    },
    {
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data.tipo_identificacion
      ),
    },
    {
      accessorKey: 'referido',
      header: 'Link Referido',
      size: 100,
      Cell: ({ row }) => (
        <div style={{ justifyContent: 'space-between' }}>
          {
            row.original.tipo_referido == 'CLIENTE' ? (
              <CopyTextOnClickComponent
                copyText={`${VITE_API_URL_OFICINA_VIRTUAL}referido/${row.original.id_preventa}`}
              />
            ) : '—'
          }
        </div>

      )
    },
    {
      accessorKey: 'tipo_referido',
      header: 'tipo referido',
      size: 200,
      Cell: ({ row }) => {
        return emptyCell(row.original.tipo_referido)
      },
    },
    {
      accessorKey: 'estado_referido',
      header: 'Estado Referido',
      size: 200,
      Cell: ({ row }) => {
        return emptyCell(row.original.estado_referido)
      },
    },
    {
      accessorKey: 'empleado_razon_social',
      header: 'Nombre Referido',
      size: 200,
      Cell: ({ row }) => {

        const tipoReferido = row.original.tipo_referido;
        return <>
          {tipoReferido === 'EMPLEADO'
            ? emptyCell(row.original.referido_empleado_data?.razon_social ?? '—')
            : emptyCell(row.original.referido_cliente_data?.razon_social ?? '—')
          }
        </>
      },
    },
    {
      accessorKey: 'prospecto_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
      Cell: ({ row }) => (
        emptyCellObject(row.original, 'celular_2')
      )
    },
    {
      accessorKey: 'email',
      header: 'email',
      size: 200,
      Cell: ({ row }) => (
        emptyCellObject(row.original, 'email')
      )
    },
    {
      accessorKey: 'tipo_referido',
      header: 'Es Referido',
      size: 150,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => (
        row.original.tipo_referido
          ? 'SI'
          : 'NO'
      ),
    },
    {
      accessorKey: 'nombre_referencia',
      header: 'Nombre Referencia',
      size: 300,
      Cell: ({ row }) => (
        fnReferido(row.original).nombre
      ),
    },
    {
      accessorKey: 'identificacion_referencia',
      header: 'Identificación de Referencia',
      size: 300,
      Cell: ({ row }) => (
        fnReferido(row.original).identificacion
      ),
    },
    {
      accessorKey: 'contacto_referencia',
      header: 'Contacto de Referencia',
      size: 300,
      Cell: ({ row }) => (
        fnReferido(row.original).contacto
      ),
    },
    {
      accessorKey: 'observaciones.observacion_1',
      header: 'Observacion 1',
      size: 100,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original.observaciones, 'observacion_1')
      ),
    },
    {
      accessorKey: 'observaciones.observacion_2',
      header: 'Observacion 2',
      size: 100,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original.observaciones, 'observacion_2')
      ),
    },
    {
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 100,
      Cell: ({ row }) => {
        return row.original.user_create != null ?
          <InfoUser user={row.original.user_create} /> : 'N/A'
      },
    },
  ], []);


  const columnsPreventaCorporativo = useMemo<MRT_ColumnDef<IPreventaCorporativo>[]>(() => [
    {
      accessorKey: 'numero_seguimiento',
      header: 'Número de Seguimiento',
      Cell: ({ row }) => row.original?.numero_seguimiento || "N/A",
      enableColumnFilter: true,
    },
    {
      accessorKey: 'razon_social',
      header: 'Razon social',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data.razon_social || "N/A",
      size: 300,
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data?.identificacion || "N/A"
    },
    {
      accessorKey: 'tipo_plan',
      header: 'Tipo Servicio',
      filterVariant: 'select',
      filterSelectOptions: TIPO_PLAN_CORPORATIVO_CHOICE,
    },
    {
      accessorKey: 'data_plan_personalizado.nombre_personalizado',
      enableColumnFilter: false,
      header: 'Nombre Enlace',
      Cell: ({ row }) => row.original?.data_plan_personalizado?.nombre_personalizado
    },
    {
      accessorKey: 'prospecto_corporativo_data.user_create',
      enableColumnFilter: false,
      header: 'asesor',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data?.user_create || "N/A"
    },
    {
      accessorKey: 'user_creador_data',
      header: 'Creador Preventa',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const creador = row.original?.user_creador_data;
        if (!creador) return "N/A";
        return creador.username || "N/A";
      }
    },
    {
      accessorKey: 'user_aprobador_prefactibilidad_data',
      header: 'Aprobador Prefactibilidad',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const aprobador = row.original?.user_aprobador_prefactibilidad_data;
        if (!aprobador) return "N/A";
        return aprobador.username || "N/A";
      }
    },

    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      Cell: ({ row }) => formatDate(row.original.fecha_creacion!),
      enableColumnFilter: false,
    },
    {
      accessorKey: 'fecha_modificacion',
      header: 'Fecha Modificación',
      Cell: ({ row }) => formatDate(row.original.fecha_modificacion!),
      enableColumnFilter: false,
    },

  ], []);

  const columnsPreventaCorporativoWithStatus = useMemo<MRT_ColumnDef<IPreventaCorporativo>[]>(() => [
    {
      accessorKey: 'numero_seguimiento',
      header: 'Número de Seguimiento',
      Cell: ({ row }) => row.original?.numero_seguimiento || "N/A",
      enableColumnFilter: true,
    },
    {
      accessorKey: 'razon_social',
      header: 'Razon social',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data.razon_social || "N/A",
      size: 300,
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data?.identificacion || "N/A"
    },
    // {
    //   ...cellNotFilter,
    //   accessorKey: 'es_demo',
    //   header: 'Es demo',
    //   Cell: ({ row }) => booleanCell(row.original.es_demo)
    // },
    {
      accessorKey: 'tipo_plan',
      header: 'Tipo Servicio',
      filterVariant: 'select',
      filterSelectOptions: TIPO_PLAN_CORPORATIVO_CHOICE,
    },
    {
      accessorKey: 'preventa_aprobada_factibilidad',
      header: 'Estado Prefactibilidad',
      Cell: ({ row }) => row.original?.preventa_aprobada_factibilidad && row.original?.estado_preventa == EstadoPreventaEnum.PREAPROBADA ? <Tooltip title="Ingrese y complete la información requerida">
        <span
          style={{ padding: '10px', backgroundColor: 'green', color: 'white', borderRadius: '5px' }}>
          APROBADO</span>
      </Tooltip>
        : <Tooltip title="La Oportunidad Comercial esta siendo revisada por Preventa Corporativa">
          <span
            style={{ padding: '10px', backgroundColor: 'orange', color: 'white', borderRadius: '5px' }}>
            EN ESPERA</span>
        </Tooltip>,
    },
    {
      accessorKey: 'data_plan_personalizado.nombre_personalizado',
      enableColumnFilter: false,
      header: 'Nombre Enlace',
      Cell: ({ row }) => row.original?.data_plan_personalizado?.nombre_personalizado
    },
    {
      accessorKey: 'observacion_prefactibilidad',
      enableColumnFilter: false,
      header: 'Observación Prefactibilidad',
      Cell: ({ row }) =>
        <Typography variant="caption">
          {row.original?.observaciones?.observacion_prefactibilidad?.toUpperCase() || "N/A"}
        </Typography>,
      size: 300,
    },
    {
      accessorKey: 'prospecto_corporativo_data.user_create',
      enableColumnFilter: false,
      header: 'asesor',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data?.user_create || "N/A"
    },
    {
      accessorKey: 'user_creador_data',
      header: 'Creador Preventa',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const creador = row.original?.user_creador_data;
        if (!creador) return "N/A";
        return creador.username || "N/A";
      }
    },
    {
      accessorKey: 'user_aprobador_prefactibilidad_data',
      header: 'Aprobador Prefactibilidad',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const aprobador = row.original?.user_aprobador_prefactibilidad_data;
        if (!aprobador) return "N/A";
        return aprobador.username || "N/A";
      }
    },

    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      Cell: ({ row }) => formatDate(row.original.fecha_creacion!),
      enableColumnFilter: false,
    },
    {
      accessorKey: 'fecha_modificacion',
      header: 'Fecha Modificación',
      Cell: ({ row }) => formatDate(row.original.fecha_modificacion!),
      enableColumnFilter: false,
    },

  ], []);


  const columnsPreventaSolicitudValorInstalacion = useMemo<MRT_ColumnDef<IDataPreventa>[]>(() => [
    {
      accessorKey: 'cliente_razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data.identificacion
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_data.tipo_identificacion
      ),
    },
    {
      accessorKey: 'valor_instalacion_total',
      header: 'valor instalacion total',
      size: 100,
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacion_1',
      header: 'Observacion 1',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacion_2',
      header: 'Observacion 2',
      size: 150,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original.observaciones, 'observacion_2')
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'fecha preventa',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta',
      size: 200
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 200,
      Cell: ({ row }) => (
        <InfoUser user={row.original.user_create}
        />
      )
    },
  ], [])

  const columnsPreventaFactibilidadCorporativo = useMemo<MRT_ColumnDef<IPreventaCorporativo>[]>(() => [
    {
      accessorKey: 'numero_seguimiento',
      header: 'Número de Seguimiento',
      Cell: ({ row }) => row.original?.numero_seguimiento || "N/A",
      enableColumnFilter: true,
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data?.identificacion || "N/A"
    },
    {
      accessorKey: 'razon_social',
      header: 'Razon social',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data.razon_social || "N/A",
      size: 400,
    },
    {
      id: 'nombre_personalizado',
      accessorKey: 'data_plan_personalizado.nombre_personalizado',
      //enableColumnFilter: false,
      header: 'Nombre Enlace',
      Cell: ({ row }) => row.original?.data_plan_personalizado?.nombre_personalizado
    },
    {
      accessorKey: 'prospecto_corporativo_data.user_create',
      enableColumnFilter: false,
      header: 'asesor',
      Cell: ({ row }) => row.original?.prospecto_corporativo_data?.user_create || "N/A"
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      Cell: ({ row }) => formatDate(row.original.fecha_creacion!),
      enableColumnFilter: false,
    },
    {
      accessorKey: 'tipo_plan',
      header: 'Tipo Servicio',
      filterVariant: 'select',
      filterSelectOptions: TIPO_PLAN_CORPORATIVO_CHOICE,
    },
    {
      accessorKey: 'user_creador_data',
      header: 'Creador Preventa',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const creador = row.original?.user_creador_data;
        if (!creador) return "N/A";
        return creador.username || "N/A";
      }
    },
    {
      accessorKey: 'user_aprobador_prefactibilidad_data',
      header: 'Aprobador Prefactibilidad',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const aprobador = row.original?.user_aprobador_prefactibilidad_data;
        if (!aprobador) return "N/A";
        return aprobador.username || "N/A";
      }
    },
    {
      accessorKey: 'fecha_modificacion',
      header: 'Fecha Modificación',
      Cell: ({ row }) => formatDate(row.original.fecha_modificacion!),
      enableColumnFilter: false,
    },

  ], []);


  return {
    columnsPendienteActualizarIA,
    columnsPreventaContratosNovedades,
    columnsPlantaExternaContratosNovedades,
    columnsPreventaEspera,
    columnsPreventa,
    columnsReferido,
    columnsPreventaCorporativo,
    columnsPreventaCorporativoWithStatus,
    columnsPreventaFactibilidadCorporativo,
    columnsPreventaSolicitudValorInstalacion
  }
}